import cls from "classnames";
import { ReactNode } from "react";
import styles from "./index.module.scss";

type Props = {
  // Point the control's aria-describedby at this to have it announced with the field.
  id?: string;
  className?: string;
  children: ReactNode;
};

/**
 * Validation message for a form control. Carries no ARIA role of its own: a
 * field references it through `aria-describedby`, so announcing it again on
 * appearance would repeat it.
 *
 * TODO: add a larger size for form- and page-level failures. Those render their
 * own error text today, at a weight this field-sized message cannot carry.
 */
export default function ErrorMessage(props: Props) {
  return (
    <span id={props.id} className={cls(styles.error, props.className)}>
      {props.children}
    </span>
  );
}
